import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import SignIn from '../SignIn';
import { logOut } from '../../actions/auth';
import { appPath } from '../../constants';
import UsersService from '../../services/UsersService';
import ContentWrapper from '../common/ContentWrapper';

class Home extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    logOut: PropTypes.func.isRequired
  };

  state = {
    isWorker: false
  };

  componentDidUpdate (prevProps) {
    const { name } = this.props.user;
    if (prevProps.user.name !== name && name === UsersService.getRoles().worker) {
      this._markUserAsWorker();
    }
  }

  _markUserAsWorker = () => this.setState({ isWorker: true });

  render () {
    if (UsersService.isAdmin()) {
      return <Redirect to={`/${appPath}/dashboard`} />;
    }

    if (UsersService.isEmployer()) {
      return <Redirect to={`/${appPath}/jobs`} />;
    }

    if (UsersService.isWorker()) {
      this.props.logOut();
    }

    return (
      <ContentWrapper full>
        <div className='auth-form-wrapper'>
          { this.state.isWorker ? (
            <div className='alert alert-static alert-danger'>We're sorry but workers must log in using the mobile app</div>
          ) : (
            <h1 className='text-center'>Welcome!</h1>
          ) }
          <SignIn />
        </div>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = state => ({ user: state.user });

export default connect(mapStateToProps, { logOut })(Home);



// WEBPACK FOOTER //
// ./src/components/app/Home.js